export const tipsCommentCardBodyStyles = { padding: '4px 12px' }
